import React from "react";
import * as styles from "./Radio.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import RadioHelper from "@app/components/RadioHelper";

const Radio = (props) => {
	return (
		<RadioHelper {...props}>
			{(inputProps) => {
				const className = classNames({
					[styles["radio"]]: true,
					[styles["is-active"]]: inputProps.isActive,
					[props.className]: !!props.className,
				});
				return (
					<label htmlFor={props.id} className={className}>
						<span className={styles["element"]} />
						<span className={styles["label"]}>{props.label}</span>
					</label>
				);
			}}
		</RadioHelper>
	);
};

Radio.propTypes = {
	label: PropTypes.string.isRequired,
	name: PropTypes.string,
	id: PropTypes.string,
	value: PropTypes.string,
	defaultValue: PropTypes.string,
	hasError: PropTypes.bool,
	onChange: PropTypes.func,
	children: PropTypes.func,
	disabled: PropTypes.bool,
	fullHeight: PropTypes.bool,
};

export default Radio;
